// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import DialogForm from '@/modules/common/components/DialogForm';
import Form from './Form';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    offer: '',
    type: '',
    status: '',
    url: '',
};

const initialErrors = {
    offer: '',
    type: '',
    status: '',
    url: '',
};

let abortController;

const DialogAdd = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const { username } = useParams();

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post(
            `/api/postbacks/?username=${username}`, {
                username: username,
                offer: values.offer,
                type: values.type,
                status: values.status,
                url: values.url
            },
            abortController
        ).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.offer = (data.offer) ? data.offer[0] : '';
                _errors.type = (data.type) ? data.type[0] : '';
                _errors.status = (data.status) ? data.status[0] : '';
                _errors.url = (data.url) ? data.url[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm title="Добавление PostBack" label="Добавить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <Form initialValues={initialValues} values={values} setValues={setValues}
                  errors={errors} setErrors={setErrors}
            />
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withFetch(Component);

export default Component;

